import { Button, Stack, TextField, Typography } from '@mui/material';

import type { StepProps } from '@/components/wizard/StepProps';

import type { UpsertApiCredentialsState } from './upsertApiCredentialsFlow';

import { validateName } from '../wizard/renameEntityName';

export const ApiCredentialsNameSelection = (
  props: StepProps<UpsertApiCredentialsState>
) => {
  const next = () => {
    props.setNextStep(props.currentStep.next?.[0]);
  };

  return (
    <Stack
      sx={{ height: '100%' }}
      alignItems='center'
      justifyContent='center'
      gap='24px'
    >
      <Typography variant='subtitle1' sx={{ textAlign: 'center' }}>
        Credentials name
      </Typography>
      <TextField
        autoFocus
        sx={{
          width: '655px',
          '& .MuiOutlinedInput-root': {
            padding: '8px',
          },
        }}
        placeholder='Example: Dashboard reports'
        onChange={(e) =>
          props.setWizardState((state) => ({
            ...state,
            name: e.target.value,
          }))
        }
        onKeyDown={(e) => {
          if (e.key === 'Enter' && validateName(props.wizardState.name)) {
            next();
          }
        }}
        value={props.wizardState.name}
        slotProps={{
          input: {
            endAdornment: (
              <Button
                sx={{ width: '200px' }}
                variant='contained'
                disabled={!validateName(props.wizardState.name)}
                onClick={next}
              >
                Next
                <i className='material-symbols-arrow-right-alt ml-[8px]' />
              </Button>
            ),
          },
        }}
      />
      <Typography
        variant='body2'
        sx={{ textAlign: 'center' }}
        className='max-w-[480px]'
      >
        Pick a name that tells you what you’ll use the credentials for, so
        you’ll always know what tools are accessing your account.
      </Typography>
    </Stack>
  );
};
